'use strict';

import GraphQL from './graphql';

export default {
  create (resourceId, resourceType, field, value) {
    const query = `mutation {
      createUserSubmission(
        resourceId: ${resourceId},
        resourceType: "${resourceType}",
        field: "${field}",
        value: "${value}",
      ) {
          id
          field
          value
          user_id
          resourceType
          resourceId
          errors
        }
    }`;

    return GraphQL.post(query);
  },


  // createMultiple(userSubmissions) {
  //   let query = "mutation {\n";
  //   [].forEach.call(userSubmissions, (userSubmission) => {
  //     query += this.query(userSubmission);
  //   });
  //   query += "}";
  //   return GraphQL.post(query);
  // },
  //
  // query(userSubmission) {
  //   return `createUserSubmission(
  //       resourceId: ${userSubmission.resourceId},
  //       resourceType: "${userSubmission.resourceType}",
  //       field: "${userSubmission.field}",
  //       value: "${userSubmission.value}",
  //     ) {
  //         id
  //         field
  //         value
  //         user_id
  //         resourceType
  //         resourceId
  //         errors
  //       } `;
  // }
};



// WEBPACK FOOTER //
// ./app/javascript/vue/services/user-submissions.js